/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Slot_LogoInputs */

const cs_builder_slot_logo = /** @type {(inputs: Builder_Slot_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

const en_builder_slot_logo = /** @type {(inputs: Builder_Slot_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo`)
};

/**
* | output |
* | --- |
* | "Logo" |
*
* @param {Builder_Slot_LogoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_slot_logo = /** @type {((inputs?: Builder_Slot_LogoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Slot_LogoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_slot_logo(inputs)
	return cs_builder_slot_logo(inputs)
});